import React from 'react';
import Header from "../../components/header";
import Footer from "../../components/footer";
import validator from "validator";
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { emailValidService } from '../../services/common/action';
import { makePatientRegisterStatus } from '../../services/patient/action';
import { NavLink } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import ThanksModel from "../common/Model/thanksModel"
import Agreement from "../common/Model/agreement";
import { onlyAlphabets, onlyNumbers} from "../common/keyValidation"


class OtherReg extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
      phone: "",
      mobile: "",
      address: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      iAgree: false,
      iConfirm: false,
      openPopUp: false,
      errors: {
        firstName: "",
        lastName: "",
        email: "",
        confirmPassword: "",
        password: "",
        phone: "",
        mobile: "",
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        iAgree: "",
        company:"",
      },
      firstNameValid: false,
      lastNameValid: false,
      emailValid: false,
      passwordValid: false,
      confirmPasswordValid: false,
      mobileValid: false,
      formValid: false,
      addressValid: false,
      address2Valid: false,
      cityValid: false,
      stateValid: false,
      zipValid: false,
      companyValid:false,
      agreeSiteRulesValidMsg: "",
      confirmRulesValidMsg: "",
      stateList: [],
      agreeModal: false,
      company: ""


    }
  }

  componentDidMount() {
    if (this.props.getByLocationDetails) {
      let data = this.props.getByLocationDetails.stateListObj;
      this.setState({
        stateList: data
      })
    }
    this.props.makePatientRegisterStatus();
  }

  agreeSiteRules = (e) => {
    this.setState(
      { iAgree: !this.state.iAgree },
      () => {
        if (this.state.iAgree) {
          this.setState({ agreeSiteRulesValidMsg: "" });
        } else {
          this.setState({
            agreeSiteRulesValidMsg:
            "Please agree to site rules"
          });
        }
      }
    );
  };

  confirmRules = (e) => {
    this.setState(
      { iConfirm: !this.state.iConfirm },
      () => {
        if (this.state.iConfirm) {
          this.setState({ confirmRulesValidMsg: "" });
        } else {
          this.setState({
            confirmRulesValidMsg:
            "Please confirm the mobile number"
          });
        }
      }
    );
  };

  validateField(fieldName, value) {
    const {
      errors,
      password,
      confirmPassword,
      firstNameValid,
      lastNameValid,
      emailValid,
      passwordValid,
      confirmPasswordValid,
      mobileValid,
      addressValid,
     
      cityValid,
      stateValid,
      zipValid,
      companyValid
     } = this.state;
    let fieldValidationErrors = errors;
    let firstNamevalid = firstNameValid;
    let lastNamevalid = lastNameValid;
    let emailvalid = emailValid;
    let passwordvalid = passwordValid;
    let confirmPasswordvalid = confirmPasswordValid;
    let mobilevalid = mobileValid;
    let addressvalid = addressValid;
    let cityvalid = cityValid;
    let statevalid = stateValid;
    let zipvalid = zipValid;
    let companyvalid = companyValid;



    switch (fieldName) {
      case "firstName":
        firstNamevalid = !(value.length < 3 || value.length > 20);
        fieldValidationErrors.firstName = firstNamevalid
          ? ""
          : "First Name should be 3 to 20 characters";
        break;
      case "lastName":
        lastNamevalid = !(value.length < 3 || value.length > 20);
        fieldValidationErrors.lastName = lastNamevalid
          ? ""
          : "Last Name should be 3 to 20 characters";
        break;
      case "email":
        emailvalid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        fieldValidationErrors.email = emailvalid
          ? ""
          : " Please enter valid Email Address";
        break;
      case "mobile":
        mobilevalid = value.match(/^\d{10}$/);
        fieldValidationErrors.mobile = mobilevalid
          ? ""
          : " Please enter 10 digit valid mobile number";
        break;

      case "password":
        passwordvalid =
          value.length >= 8 &&
          value.match(
            /(?=.*[_!@#$%^&*-])(?=.*\d)(?!.*[.\n])(?=.*[a-z])(?=.*[A-Z])^.{8,}$/
          );
        fieldValidationErrors.password = passwordvalid
          ? ""
          : "Must contain at least one uppercase letter, one lowercase letter, one number, one special character and a minimum of 8 characters";
        break;
      case "confirmPassword":
        confirmPasswordvalid = validator.equals(value, password);
        fieldValidationErrors.confirmPassword = confirmPasswordvalid
          ? ""
          : "Password does not match";
        break;

      case "address":
        addressvalid = !(value.length < 1);
        fieldValidationErrors.address = addressvalid
          ? ""
          : "Please enter the address";
        break;

      case "city":
        cityvalid = !(value.length < 1);
        fieldValidationErrors.city = cityvalid
          ? ""
          : "Please enter the city"
        break;

      case "state":
        statevalid = !(value.length < 1);
        fieldValidationErrors.state = statevalid
          ? ""
          : "Please enter the state"
        break;

      case "zip":
        zipvalid = !(value.length < 5);
        fieldValidationErrors.zip = zipvalid
          ? ""
          : "Please enter the zip"
        break;

        case "company":
        companyvalid = !(value.length < 1);
        fieldValidationErrors.company = companyvalid
          ? ""
          : "Please enter the company name"
        break;
      default:
        break;
    }
    if (fieldName === "password") {
      if (confirmPassword !== "") {
        if (value !== confirmPassword) {
          fieldValidationErrors.confirmPassword = "Password does not match.";
        } else {
          fieldValidationErrors.confirmPassword = "";
        }
      }
    } else if (fieldName === "confirmPassword") {
      if (value !== password) {
        fieldValidationErrors.confirmPassword = "Password does not match.";
      } else {
        fieldValidationErrors.confirmPassword = "";
      }
    }

    this.setState(
      {
        errors: fieldValidationErrors,
        firstNameValid: firstNamevalid,
        lastNameValid: lastNamevalid,
        emailValid: emailvalid,
        passwordValid: passwordvalid,
        confirmPasswordValid: confirmPasswordvalid,
        mobileValid: mobilevalid,
        addressValid: addressvalid,
        cityValid: cityvalid,
        stateValid: statevalid,
        zipValid: zipvalid,
        companyValid:companyvalid,
      },
      this.validateForm
    );
  }


  closeAgreeModal = () => {
   // document.body.classList.remove('modal-open');

    this.setState({
      agreeModal: false
    })
  }

  agreeModalOpen = ()=>{
   // document.body.classList.add('modal-open');

    this.setState({
      agreeModal :true
    })
  }

  validateForm() {
    const {
      firstNameValid,
      lastNameValid,
      emailValid,
      passwordValid,
      confirmPasswordValid,
      mobileValid,
      addressValid,
      cityValid,
      stateValid,
      zipValid,
      companyValid,


    } = this.state;

    this.setState({
      formValid:
      firstNameValid &&
      lastNameValid &&
      emailValid &&
      passwordValid &&
      confirmPasswordValid &&
      mobileValid &&
      addressValid &&

      cityValid &&
      stateValid &&
      zipValid &&
      companyValid

    });
  }


  handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  };








  registerCall = (e) => {
    e.preventDefault();

    const {
      email,
      firstName,
      lastName,
      password,
      confirmPassword,
      mobile,
      address,
      address2,
      city,
      state,
      zip,
      company} = this.state;




    let payLoad = {
      "userType": "other",
      dateOfBirth: "12-05-1996",
      address,
      address2,
      city,
      state,
      zip,
      mobile,
      email,
      firstName,
      lastName,
      password,
      confirmPassword,
      companyName:company,
    }
    const formData = new FormData();
    formData.append('commonUserDetails', JSON.stringify(payLoad))

    let email_id = {
      email
    }
    let mobileNum = {
      mobile
    }

    this.props.emailValidService(payLoad.userType, email_id, mobileNum, formData);


    // this.props.patientRegisterService(formData);

  }

  componentWillReceiveProps = nextProps => {

    if (nextProps.PatientRegisterStatus === true) {
   // document.body.classList.add('modal-open');

      this.setState({ openPopUp: true })
    } else {
      toast.error(nextProps.message);
    }

  };
  closePop = () => {
   // document.body.classList.remove('modal-open');

    this.setState({
      closePop: false
    })
  }
  confirmOkay = () => {
   // document.body.classList.remove('modal-open');

    this.setState({
      openPopUp: false
    })
    this.props.history.push("/login");

  }
 

  render() {
    const {
      firstName,
      lastName,
      email,
      password,
      confirmPassword,
     
      mobile,
    
      city,
      state,
      zip,
      iAgree,
     
      errors,
      formValid,
    
      company

    } = this.state;
    return (
      <>


      <div class="registration-wrapper">
        <Header routes={[{ "name": "Registration", "route": "/Register", }, { "name": "Third Party Requestor Registration", "route": "/OtherReg", }]} />

        {/* <!-- Content Section --> */}
        <div class="register-content">
          <div class="container">
            <div class="form-head">
              <h1>Third Party Requestor Registration</h1>
            </div>
            <div class="form-body">
              <form onSubmit={this.registerCall} autocomplete="off">
                <div class="row">

                  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="form-group r-form">
                      <label for="fname">First Name</label><sup>*</sup>
                      <input type="text" class="form-control r-txt"  onKeyPress={onlyAlphabets} name="firstName" value={firstName}
                        id="fname" onChange={this.handleChange} placeholder="First Name" />
                      <div class="r-icon">
                        <i class="fa fa-user" aria-hidden="true"></i>
                      </div>

                    </div>
                       <span style={{ color: "red" }}>{errors.firstName}</span>
                    
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="form-group r-form">
                      <label for="lname">Last Name</label><sup>*</sup>
                      <input type="text" name="lastName" class="form-control r-txt" id="lname"
                        value={lastName} onChange={this.handleChange}  onKeyPress={onlyAlphabets} placeholder="Last Name" />
                      <div class="r-icon">
                        <i class="fa fa-user" aria-hidden="true"></i>
                      </div>
                    </div>
                    <span style={{ color: "red" }}>{errors.lastName}</span>
                  </div>

                </div>
                <div class="row">

                  <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="form-group r-form">
                      <label for="email">Email</label><sup>*</sup>

                      <input type="text" name="email" class="form-control r-txt" id="email"
                        value={email} onChange={this.handleChange} placeholder="Email" />
                      <div class="r-icon">
                        <i class="fa fa-envelope" aria-hidden="true"></i>
                      </div>
                    </div>
                    <span style={{ color: "red" }}>{errors.email}</span>

                  </div>
                  <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                    <div class="form-group r-form">
                      <label for="phone">Phone</label>
                      <div className="mobile-code">
                        <input type="text" class="form-control r-txt r-phone" id="phone" onKeyPress={onlyNumbers} maxLength="10" />
                        <div class="r-icon">
                          <i class="fa fa-phone" aria-hidden="true"></i>
                        </div>
                        <div class="country-code-phone">
                          <label>+1</label>
                        </div>
                      </div>
                    </div>
                   
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                    <div class="form-group r-form">
                      <label for="mobile">Mobile </label><sup>*</sup>
                      <div className="mobile-code">
                        <input type="text" maxLength="10" class="form-control r-txt r-phone" id="mobile"
                          name="mobile" value={mobile} onChange={this.handleChange} onKeyPress={onlyNumbers} placeholder="Mobile Number" />

                        <div class="r-icon">
                          <i class="fa fa-phone" aria-hidden="true"></i>
                        </div>
                        <div class="country-code-phone">
                          <label>+1</label>
                        </div>
                        
                      </div>
                      <span style={{ color: "red" }}>{errors.mobile}</span>
                    </div>

                  </div>


                </div>
                <div class="row">






                </div>
                <div class="row">

                  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="form-group r-form">
                      <label for="pass">Password</label><sup>*</sup>
                      <input type="password" name="password" class="form-control r-txt" id="pass" value={password}
                        onChange={this.handleChange} placeholder="Password" />
                      <div class="r-icon">
                        <i class="fa fa-lock" aria-hidden="true"></i>
                      </div>
                    </div>
                    <span style={{ color: "red" }}>{errors.password}</span>

                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="form-group r-form">
                      <label for="cpass">Confirm Password</label><sup>*</sup>
                      <input type="password" name="confirmPassword" class="form-control r-txt" id="cpass" value={confirmPassword}
                        onChange={this.handleChange} placeholder="Confirm Password" />
                      <div class="r-icon">
                        <i class="fa fa-lock" aria-hidden="true"></i>
                      </div>
                    </div>
                    <span style={{ color: "red" }}>{errors.confirmPassword}</span>

                  </div>

                </div>
                <div class="row">

                  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="form-group r-form">
                      <label for="address1">Address 1</label><sup>*</sup>

                      <textarea class="form-control r-txt-area" rows="2" id="address1" name="address"
                        onChange={this.handleChange} placeholder="Address" ></textarea>
                    </div>
                    <span style={{ color: "red" }}>{errors.address}</span>

                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="form-group r-form">
                      <label for="address2">Address 2</label>
                      <textarea class="form-control r-txt-area" rows="2" id="address2" name="address2"
                        onChange={this.handleChange} placeholder="Address2"></textarea>
                    </div>
                    <span style={{ color: "red" }}>{errors.address2}</span>
                  </div>

                </div>
                <div class="row">

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="form-group r-form">
                      <label for="city">City</label><sup>*</sup>
                      <input type="text" name="city" value={city} class="form-control r-txt" id="city"
                        onChange={this.handleChange} placeholder="City" />

                    </div>
                    <span style={{ color: "red" }}>{errors.city}</span>

                  </div>





                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="form-group r-form">

                      <label for="state">State</label><sup>*</sup>
                      <select className="form-control" id="sel1" name="state" value={state} onChange={this.handleChange}>

                        <option >State </option>
                        {this.state.stateList.length > 0 ?
                          this.state.stateList.map((state, id) => {
                            return (
                              <option key={id}>{state.name} </option>

                            )
                          }) : ""

                        }

                      </select>
                    </div>
                    <span style={{ color: "red" }}>{errors.state}</span>

                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="form-group r-form">

                      <label for="zip">Zip</label><sup>*</sup>

                      <input type="text" name="zip" value={zip}
                        onChange={this.handleChange} onKeyPress={onlyNumbers} placeholder="Zip" maxLength="5"
                        class="form-control r-txt" id="zip" />
                    </div>
                    <span style={{ color: "red" }}>{errors.zip}</span>

                  </div>
                 

                </div>
                <div class="row">
                  
                  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="form-group r-form">

                      <label for="company">Name of Company</label><sup>*</sup>

                      <input type="text" name="company" value={company}
                        onChange={this.handleChange} placeholder="Name of Company"
                        class="form-control r-txt" id="Company" />
                    </div>
                    <span style={{ color: "red" }}>{errors.company}</span>

                  </div>
                  </div>
                
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="button-left">
                      <NavLink to="/Register">
                        <button class="btn cancel-btn">Previous</button>
                      </NavLink>
                    </div>
                    <div class="button-right">
                      <div className="form-group r-form-btn">

                        <div className="rememberme ">
                          <input type="checkbox" id="cbx"
                            onChange={this.agreeSiteRules} className="inp-cbx" />
                          <label htmlFor="cbx" className="cbx">
                            <a href="javascript:void(0)"  onClick={this.agreeModalOpen} className="check-agree" > I agree to Terms of Use </a>
                          </label>
                          {/* <input type="checkbox" id="cbx" name="iAgree"
                        onChange={this.agreeSiteRules} className="inp-cbx" style={{ display: "none" }} />
                      <label htmlFor="cbx" className="cbx">
                        <span>
                          <svg width="12px" height="10px" viewBox="0 0 12 10">
                            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                          </svg>
                        </span>
                        <span><a href="javascript:void(0)" onClick={()=>{this.setState({agreeModal:true})}} className="check-agree">&nbsp;&nbsp;I agree to site rules</a></span>
                        
                      </label> */}
                        </div>

                      </div>
                      <button type="submit" disabled={!formValid || !iAgree} class="btn submit-btn">Submit</button>
                    </div>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>

        {/* <!-- Footer Section --> */}
        <Footer />
      </div>

      <ThanksModel header="Thank you for registering with ePaper Road" text="We have sent a link to your email. Please click the link to activate your account. Thank you" page="PatientRegister" status={this.state.openPopUp} confirmOkay={this.confirmOkay} />
        {/* <Model header="Thank you for registering with ePaper Road" text="Your Registration process completed we have send you a verification link to your mail" page="PatientRegister" status={this.state.openPopUp} confirmOkay={this.confirmOkay} /> */ }
    <Agreement email={email} emailValid={this.state.emailValid} role="other" status={this.state.agreeModal} closeAgreeModal={this.closeAgreeModal} /> 

      </>
    )
  }
}

const mapStateToProps = state => ({
  PatientRegisterDetails: state.patientReducer.PatientRegisterDetails,
  message: state.commonReducer.message,
  PatientRegisterStatus: state.patientReducer.PatientRegisterStatus,
  getByLocationDetails: state.patientReducer.getByLocationDetails,
  mobileValidStatus: state.commonReducer.mobileValidStatus,
  emailValidStatus: state.commonReducer.emailValidStatus,
  //isLoading: state.commonReducer.isLoading 
});

const mapDispatchToProps = dispatch => ({
  emailValidService: (userType, email_id, mobileNum, formdata) => dispatch(emailValidService(userType, email_id, mobileNum, formdata)),
  makePatientRegisterStatus: () => dispatch(makePatientRegisterStatus()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(OtherReg));